import { render, staticRenderFns } from "./BaseHeroScroll.vue?vue&type=template&id=6b47ca64&scoped=true&"
import script from "./BaseHeroScroll.vue?vue&type=script&lang=js&"
export * from "./BaseHeroScroll.vue?vue&type=script&lang=js&"
import style0 from "./BaseHeroScroll.vue?vue&type=style&index=0&id=6b47ca64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b47ca64",
  null
  
)

export default component.exports